export class UserActions{
  public static readonly TreeDuxUA:string[] = ['601f7702-efcb-449e-a0e7-a208107f9ffe', 
                                               '10c52cd9-d522-4e5b-9b6c-bfff2c4830b0',
                                               '8a12806e-c3eb-4003-b31c-b309fc8ab18d',
                                               '99572e28-ec78-44de-835e-953ce1d6d5ed',
                                               '6c817186-344f-4edc-b2d2-bf1e6ef1f1e8',
                                               'bf9bf4b1-b53c-41fe-a203-c39a5a99ac5b',
                                               '9b9f3502-61d2-4e69-b4e1-d2360a8501d1',
                                               '5788ee20-a764-4dc4-a878-553dd2e195aa'];
  public static readonly AddColumnUA = '6423c9eb-4e5d-49ae-9fe2-fae41d9b7b97';
  public static readonly RemoveColumnUA = 'f220428d-7693-4dfc-b67d-a020c174f53f';
  public static readonly NewTreeCollectionUA = 'bf9bf4b1-b53c-41fe-a203-c39a5a99ac5b';
  public static readonly GetSelectedUA = '31895aca-55fa-4b61-b4a0-92c8074fb629';
  public static readonly ShowRunTimeKeysUA = "8ccd6db2-4247-4ad8-8f83-33ec794126b1";
  public static readonly SwitchToBackendAppUA = "2f1be8d2-d488-40e1-ad9e-bd512d564ba7";


                                              }


export class TreeRequest
{
  public cosyToken:string;
  public id:string;
  public groupID:string;
  public entityID:string;
  public entityItemID:string;
  public name:string;
}

export class TreeResult
{
  public tree:any;
  public id:string;
}